import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NavigationMenu from '../Menu/NavigationMenu.jsx';
import styles from '../Navigation.less';
import NavigationArrow from './NavigationArrow';
import { getIsNavigationHeaderFolded, getIsSidebarDesktopExpanded, getPageViewId } from '../../../selectors/selectors';
import actions from '../actions';
import tracking from '../../../tracking/tracking.js';
import { INTERACTIVE_ATLAS_NAVI_COLLAPSE, INTERACTIVE_ATLAS_NAVI_EXPAND } from '../../../tracking/trackingNaming';
import { isFeatureOn } from '../../../utils/featureSwitchReader';
import NewNavigationHeader from '../Header/NewNavigationHeader';
import SavingAddressSearch from '../../AddressSearch/AddressSearch/SavingAddressSearch';

export class NavigationSidebarDesktop extends React.Component {
  constructor(props) {
    super(props);
    this.container = React.createRef();

    this.bodyClickHandler = this.bodyClickHandler.bind(this);
    this.state = {
      isComponentMounted: false
    };
  }

  componentDidMount() {
    document.body.addEventListener('click', this.bodyClickHandler);
    this.setState({
      isComponentMounted: true
    });
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.bodyClickHandler);
    this.setState({
      isComponentMounted: false
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    document.body.setAttribute('data-sidebar-expanded', this.props.isSidebarDesktopExpanded.toString());
  }

  bodyClickHandler(event) {
    if (!this.props.isExpanded) {
      return;
    }

    const isClickedTargetInContainer = this.container.current.contains(event.target);

    if (!isClickedTargetInContainer) {
      this.props.onFocusOut();
    }
  }

  isExpanded() {
    return this.state.isComponentMounted ? this.props.isSidebarDesktopExpanded : true;
  }

  render() {
    const {
      isNavigationHeaderFolded,
      toggleSidebarDesktop,
      pageTitle,
    } = this.props;

    return (
      <div
        className={`grid border-right ${styles.nav_bar} ${this.isExpanded() ? '' : styles.folded}`}
        ref={this.container}
      >
        {
          (
            this.isExpanded() ? (
              <>
                <SavingAddressSearch className={`padding-m padding-top-l`} style={{ display: 'none' }} />
                <div className={`grid padding-m ${styles.nav_header} ${isNavigationHeaderFolded ? styles.folded : ''}`}>
                  <NewNavigationHeader />
                </div>
              </>
            ) : (
              <div className={`grid-item ${styles.navigation_search}`}>
              <span
                id="navigation-search"
                onClick={toggleSidebarDesktop}
                className="font-xl grid grid-item font-lightgrey is24-icon-search"
                role="button"
                onKeyDown={(event)=> {
                  if (event.key === 'ArrowUp'){
                    toggleSidebarDesktop()
                  }
                }}
                tabIndex={0}
              />
              </div>
            )
          )
        }

        <NavigationMenu collapsed={!this.isExpanded()} />
        <NavigationArrow
          sidebarDesktopExpanded={this.isExpanded()}
          toggleSidebarDesktop={() => {
            const label = this.isExpanded() ? INTERACTIVE_ATLAS_NAVI_COLLAPSE : INTERACTIVE_ATLAS_NAVI_EXPAND;
            this.props.reportData({ label, pageTitle });
            toggleSidebarDesktop();
          }}
        />
      </div>
    );
  }
}

NavigationSidebarDesktop.defaultProps = {
  subTitle: '',
  reportData: tracking.reportData,
  isFeatureOn,
};

NavigationSidebarDesktop.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  isNavigationHeaderFolded: PropTypes.bool.isRequired,
  toggleSidebarDesktop: PropTypes.func.isRequired,
  isSidebarDesktopExpanded: PropTypes.bool.isRequired,
  reportData: PropTypes.func,
  isFeatureOn: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isNavigationHeaderFolded: getIsNavigationHeaderFolded(state),
  isSidebarDesktopExpanded: getIsSidebarDesktopExpanded(state),
  pageTitle: getPageViewId(state),
});

const mapDispatchToProps = {
  toggleSidebarDesktop: () => actions.toggleSidebarDesktop(),
};

const ConnectedSidebar = connect(mapStateToProps, mapDispatchToProps)(NavigationSidebarDesktop);

export default ConnectedSidebar;
